import { Grid } from "@mui/material";
import BigNumber from "../../BigNumber";
import kpiVocabulary from "../../../../vocabulary/kpis";

const Section = ({ storyKPIs, gaSummarized }) => (
  <Grid item xs={12} sm={12} md={12}>
    <Grid container spacing={2}>
      <BigNumber
        title="Pageviews"
        value={storyKPIs.screenPageViews}
        size="sm"
      />
      <BigNumber
        title="Avg Time on Page"
        value={storyKPIs.averageSessionDuration}
        unit="s"
        size="sm"
      />
      <BigNumber title="CTA Clicks" value={storyKPIs.ctaClicks} size="sm" />
      <BigNumber
        title="Outbound Clicks"
        value={storyKPIs.outboundClicks}
        size="sm"
      />
      <BigNumber
        title="Video Plays"
        value={gaSummarized?.videoPlays || storyKPIs.videoPlays}
        size="sm"
      />
      <BigNumber
        title="Avg Scroll Depth"
        value={storyKPIs.scrollDepth}
        unit="%"
        size="sm"
      />
      <BigNumber value={storyKPIs.shares} title="Shares" size="sm" />
      <BigNumber
        value={storyKPIs.formSubmissions}
        title={kpiVocabulary.formSubmissions.description}
        size="sm"
      />
      <BigNumber value={storyKPIs.impressions} title="Impressions" size="sm" />
      <BigNumber value={storyKPIs.clicks} title="Clicks" size="sm" />
      <BigNumber
        value={storyKPIs.ctr}
        title="CTR"
        unit="%"
        decimals={3}
        size="sm"
      />
    </Grid>
  </Grid>
);

export default Section;
